export default "__VITE_ASSET__BMDHEICF__"